import { GridColDef } from '@mui/x-data-grid';
import { StaffProps } from '../types';
import { IconButton, Tooltip } from '@mui/material';
import Icons from '../../../components/icons';
import { profileImgStyle, TableProfileWrapper } from '../styled';
import pallet from '../../../layouts/pallet';

export const getStaffTableColumns = (
  handleEditClick: (Id: string) => void
): GridColDef[] => [
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    minWidth: 160,
    renderCell: (params) => {
      const row = params.row as StaffProps;

      return (
        <TableProfileWrapper>
          {row.profile ? (
            <img src={row.profile} alt={row.name} style={profileImgStyle} />
          ) : (
            <Icons.Avatar style={profileImgStyle} />
          )}
          <span style={{ fontWeight: 700, color: pallet.formLabelText }}>
            {row.name}
          </span>
        </TableProfileWrapper>
      );
    }
  },
  {
    field: 'email',
    headerName: 'Email',
    minWidth: 160,
    flex: 1,
    sortable: false
  },
  {
    field: 'gender',
    headerName: 'Gender',
    minWidth: 180
  },
  {
    field: 'action',
    headerName: 'Action',
    sortable: false,
    filterable: false,
    headerAlign: 'center',
    align: 'center',
    disableColumnMenu: true,
    resizable: false,
    renderCell: (params) => {
      const row = params.row as StaffProps;
      return (
        <Tooltip title='Edit'>
          <IconButton onClick={() => handleEditClick(row.id)}>
            <Icons.EditBlackOutlined />
          </IconButton>
        </Tooltip>
      );
    }
  }
];
